/**
 *
 * Modal
 *
 */

import React from 'react';
import { Modal as AntdModal } from 'antd';

import Icon from '../Icon';
import Button from '../Button';
import './styles.css';
// import styled from 'styled-components';

function Modal({
  acceptButtonText,
  cancelButtonText,
  title,
  closable,
  visible,
  onAccept,
  onCancel,
  footer,
  loading,
  ...rest
}: any) {
  return (
    <AntdModal
      wrapClassName="vertical-center-modal"
      width="fit-content"
      {...rest}
      title={title}
      closeIcon={<Icon type="close" style={{ objectFit: 'contain' }} />}
      footer={null}
      closable={closable !== undefined ? closable : true}
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
    >
      {rest.children}
      {footer && (
        <div className="modal-btn-container">
          <Button text={cancelButtonText || 'Cancel'} onClick={onCancel} />
          <Button
            loading={loading}
            type="primary"
            text={acceptButtonText || 'Apply'}
            onClick={onAccept}
          />
        </div>
      )}
    </AntdModal>
  );
}

export default Modal;
export { AntdModal };
